<template>
  <div id="ConnectUsPage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid container-md py-10">
        <div class="row">
          <div class="col-12 text-center">
            <h1>
              <span class="font-19 border-bottom-gold px-5">تماس با ما</span>
            </h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="text-center px-5">
              <v-img :src="$replaceHttps(fileUrl)"></v-img>
              <a class="mt-3" v-if="link !== null" :href="link" target="_blank">
                <v-btn color="primary" class="mt-3" elevation="0">مشاهده لینک </v-btn>
              </a>
              <div class="mt-4 font-16" v-html="descriptions"></div>
              <!--                                <div class="mt-4">شماره دفتر مرکزی: {{officePhone}}</div>-->
              <!--                                <div class="mt-4">آدرس دفتر مرکزی:</div>-->
              <!--                                <div class="mt-3">{{officeAddress}}</div>-->
            </div>
          </div>
          <div class="col-12">
            <h4 class="title-border-bottom text-center pb-5 mt-8">شبکه های اجتماعی</h4>
            <div class="row">
              <div v-for="item in socialNetworkItems" :key="item.SocialNetworkID"
                   class="col-auto mt-9 text-center">
                <div v-if="item.IsActive">
                  <a :href="item.Link" target="_blank">
                    <v-img :src="$replaceHttps(item.FileUrl)" :alt=item.name height="75" width="75" contain></v-img>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <GmapMap
                ref="mapRef"
                :center="myCoordinates"
                :options='{ fullscreenControl: false, mapTypeControl: false }'
                :zoom="zoom"
                style="height:360px"
            >
              <GmapMarker
                  v-for='(marker,index) in markers'
                  :key="index"
                  :animation="2"
                  :clickable="true"
                  :position="marker"
                  @click="center=marker"/>
            </GmapMap>
          </div>
          <div class="col-12">
            <h3 class="text-center secondary-text h5">لینک های مسیریابی</h3>
            <div class="row">
              <div class="col-3 text-center">
                <a :href="'https://www.google.com/maps/dir///'
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                   target="_blank">
                  <img alt="آدرس آموزش املاک"
                       class="img-fluid"
                       src="../../assets/img/directions/google.png"
                       title="آدرس آموزش املاک"
                  />
                </a>
              </div>
              <div class="col-3 text-center">
                <a :href="'https://waze.com/ul?ll='
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                   target="_blank">
                  <img alt="آدرس آموزش املاک" class="img-fluid"
                       src="../../assets/img/directions/waze.png"
                       title="آدرس آموزش املاک"
                  />
                </a>
              </div>
              <div class="col-3 text-center">
                <a :href="'https://neshan.org/maps/routing/car/destination/'
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                   target="_blank">
                  <img alt="آدرس آموزش املاک" class="img-fluid"
                       src="../../assets/img/directions/neshan.png"
                       title="آدرس آموزش املاک"
                  />
                </a>
              </div>
              <div class="col-3 text-center">
                <a :href="'https://balad.ir/directions/driving?destination='
                  + myCoordinates.lng + ',' + myCoordinates.lat"
                   target="_blank">
                  <img alt="آدرس آموزش املاک" class="img-fluid"
                       src="../../assets/img/directions/balad.png"
                       title="آدرس آموزش املاک"
                  />
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "ConnectUs",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavBar, FooterComponent},
  data: () => ({
    showLoaderDialog: false,
    descriptions: '',
    fileUrl: '',
    link: null,
    socialNetworkItems :[],
    myCoordinates: {
      lat: 35.76253959705312,
      lng: 51.31123557422541
    },
    center: {
      lat: 35.76253959705312,
      lng: 51.31123557422541
    },
    zoom: 16,
    markers: [
      {
        lat: 35.76253959705312,
        lng: 51.31123557422541
      }
    ],
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetPage?typePage=2", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.aboutUsText = json.Description
            this.fileUrl = json.FileUrl
            this.link = json.Link
            this.showLoaderDialog = false
            this.getSocial()
          })
          .catch(error => console.log('error', error));
    },
    getSocial(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetSocialNetworks", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.socialNetworkItems = JSON.parse(result).filter(x => x.IsActive)
          })
          .catch(error => console.log('error', error));
    }
  }

}
</script>
